import { HttpErrorResponse } from '@angular/common/http';
import { inject,Injectable,Injector } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';

/**
 * Shape files Service
 *
 * This service retrieves the region files from the API
 */
@Injectable({
  providedIn: 'root'
})
export class CustomSnackbarService extends MatSnackBar {
  private injector = inject(Injector);
  /**
   * Method that presents the snackbar, with a static duration
   *
   * @param message Message to show
   * @param action Action buttons
   * @param duration The duration of the displayed snackbar
   *
   * @returns Reference to the snackbar
   */
  public present(message: string, action = '', duration = 3000): MatSnackBarRef<SimpleSnackBar> {
    return this.open(message, action, { duration });
  }

  /**
   * Returns the error message if exist, in other case returns 'Something went wrong'
   *
   * @param e Error response from subscribe
   */
  public showError(e: HttpErrorResponse): Observable<never> {
    const errorMessage = e.error && e.error.message ? 'Error: ' + e.error.message : 'Error: Something went wrong';
    this.present(errorMessage);

    return throwError(e);
  }

  /**
   * Returns an error with its related translation if exists, in other case returns 'Something went wrong'
   *
   * @param err Error response object
   */
  public showTranslatedError(err: HttpErrorResponse): Observable<never> {
    const translate = this.injector.get(TranslateService);

    let errorKey = err.error ? err.error.errors || err.error.message : 'genericError';
    if (!err.error || !err.error.message || err?.error?.errors) {
      errorKey = 'Error.' + errorKey;
    }

    const errorMessage = translate.instant(errorKey);
    this.present(errorMessage);

    return throwError(err);
  }
}
